import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { Address } from '../../model/address';
import { AddressService } from '../../services/address.service';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';

@Component({
  selector: 'app-address-number',
  templateUrl: './address-number.page.html',
  styleUrls: ['./address-number.page.scss'],
})
export class AddressNumberPageComponent extends DefaultPageComponent implements OnInit {

  public number = '';
  public idComponentName = 'address-number';
  placeholder = '';
  error = false;
  buttonEnable = false;
  textError = '';
  invalidErrorText = 'Número inválido';
  idLabel = 'page-address-number';
  label = 'qual o número da residência';
  headerId = 'address-number';
  adress: Address[];
  addressName = '';
  titlePage = 'Endereço';
  startStage = '';
  endStage = '';
  analyticsPage: AnalyticsPageModel;

  addressNumberForm = this.formBuilder.group({
    numberAddress: this.formBuilder.control('', [FormValidations.validationsNumberAddress])
  });

  constructor(private formBuilder: FormBuilder,
              public router: NavController,
              public backNativeService: BackNativeService,
              private addressService: AddressService,
              private title: Title,
              public journeyService: JourneyService,
              public returnNativeService: ReturnNativeService,
              public analycticsNativeService: AnalycticsNativeService,
              private analyticsPageService: AnalyticsPageService,
            ) {
              super(backNativeService, journeyService, router, returnNativeService);
              this.getAnalyticsPage();
              this.analyticsData();
              this.getTrack();
            }
/* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.addressName = this.journeyService.registratioJourney.data.address.street;
    this.editFieldInvest('numero', 'number', 'address');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'address';

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.addressNumber;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  backPage() {
    this.analyticsEventClique();
    if (this.addressService.addressInitalPostCode?.street) {
        return this.router.navigateBack(['address', 'cep']);
    }

    this.back();
  }

  errorMessage() {
    const control = this.addressNumberForm.get('numberAddress') as FormControl;
    this.error = control.errors !== null || control.value < 0;

    this.error ? this.buttonEnable = false : this.buttonEnable = true;

    if (control.errors !== null && control.errors.hasOwnProperty('repeated')) {
      this.textError = this.invalidErrorText;
    }
    if (control.errors !== null && control.errors.hasOwnProperty('nameSpace') ||
    control.errors !== null && control.errors.hasOwnProperty('minlengthNumerAddress')) {
      this.textError = this.invalidErrorText;
    }
  }

  clickNext() {
    this.addressService.setAddressNumber(this.number);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = { 
              it_eventaction: this.analyticsPage.action,
              it_eventlabel: this.analyticsPage.back,
              it_pagename: this.analyticsPage.addressNumber,
            };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.address.number) {
      this.number = this.journeyService.registratioJourney.data.address.number;
      this.addressNumberForm.controls.numberAddress.setValue(this.journeyService.registratioJourney.data.address.number);
      this.addressName = this.journeyService.registratioJourney.data.address.street;
      this.errorMessage();
    }  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }
  
}
